import type { LocaleDictionary } from "@/i18n/types";

const nsGridEN = {
  unknownStatus: "Unknown Status",
  otherColumn: "Actions",
  enabled: "Enabled",
  disabled: "Disabled",
  memberCount: ({ count, max }: { count: number; max: number }) =>
    `${count} / ${max} members`,
  memberCountUnlimited: ({ count }: { count: number }) =>
    `${count} / Unlimited members`,
} satisfies LocaleDictionary;

export default nsGridEN;
